import React from "react";
import PropTypes from "prop-types";
import "./BrandHero.css";

/**
 * 브랜드 히어로 영역(헤더)
 * @param brand
 * @returns {JSX.Element}
 * @constructor
 */
export default function BrandHero({ brand }) {
  return (
    <header className="BrandHero">
      <div className="BrandHero-inner">
      <div className="BrandHero-content">
        <div className="BrandHero-label">Brand</div>
        <h1 className="BrandHero-name">{brand.name}</h1>
        {brand.name_kr && (
          <div className="BrandHero-name-kr">
            {brand.name_kr}
          </div>
        )}
        <div className="BrandHero-stats">
          <div className="BrandHero-stat">
            <div className="BrandHero-stat-value">
              {(brand.follow_count || 0).toLocaleString()}
            </div>
            <div className="BrandHero-stat-label">Followers</div>
          </div>
          <div className="BrandHero-stat">
            <div className="BrandHero-stat-value">
              {(brand.product_count || 0).toLocaleString()}
            </div>
            <div className="BrandHero-stat-label">Listings</div>
          </div>
        </div>
        {brand.description && (
          <p className="BrandHero-desc">{brand.description}</p>
        )}
      </div>
      {brand.resizedSmallLogo && (
        <div className="BrandHero-img">
          <img src={brand.resizedSmallLogo} alt={brand.name_kr || brand.name} width={160} height={160} />
        </div>
      )}
      </div>
    </header>
  );
}

BrandHero.propTypes = {
  brand: PropTypes.shape({
    name: PropTypes.string.isRequired,
    name_kr: PropTypes.string,
    follow_count: PropTypes.number,
    product_count: PropTypes.number,
    description: PropTypes.string,
    resizedSmallLogo: PropTypes.string,
  }).isRequired,
};
